module.exports = __webpack_public_path__ + "static/media/Code_Ethique_CASH_Spa.0b12b242.pdf";